import { Controller } from "@hotwired/stimulus"

// Auto-dismisses flash messages after a delay. Dismissal is driven by JS rather
// than a CSS animation that ends off-screen, so flashes stay visible while on
// screen even when animations are disabled (e.g. Capybara.disable_animation in
// system specs).
export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.dismissTimeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.dismissTimeout)
    clearTimeout(this.removeTimeout)
  }

  dismiss() {
    this.element.classList.add("flash--dismissing")
    this.removeTimeout = setTimeout(() => this.element.remove(), 500)
  }
}
